import React from 'react'

type CheckIconProps = {
  className: string
}

function CheckIcon({ className }: CheckIconProps) {
  return (
    <svg
      className={className}
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 9.5L8.5 16L17.5 4.5" stroke="#00B333" strokeWidth="1.85" strokeLinecap="round" />
    </svg>
  )
}

export default CheckIcon
